// eslint-disable-next-line
import { UserActionsTypes } from '../../actions';
import localStorageFacade, { LocalStorageKeys } from '../../../utils/localStorageFacade';

const initialState = { authenticated: false };
export default (state = initialState, { type }) => {
  switch (type) {
    case UserActionsTypes.GOOGLE_AUTH.SUCCESS:
    case UserActionsTypes.BASIC_AUTH.SUCCESS:
    case UserActionsTypes.CHECK_AUTH.SUCCESS:
      return { authenticated: true };
    case UserActionsTypes.BASIC_AUTH.FAIL:
    case UserActionsTypes.GOOGLE_AUTH.FAIL:
    case UserActionsTypes.CHECK_AUTH.FAIL:
    case UserActionsTypes.LOGOUT:
      localStorageFacade.remove(LocalStorageKeys.AUTH_TOKEN);
      return initialState;
    default:
      return state;
  }
};
